export const DEFAULT_THEME = 'true-dark';

const SUPPORTED_THEMES = new Set(['light', 'dark', 'true-dark', 'neon']);

export const normalizeTheme = (value) => {
  const theme = String(value || '').trim();
  return SUPPORTED_THEMES.has(theme) ? theme : DEFAULT_THEME;
};

export const getNextTheme = (value) => {
  const theme = normalizeTheme(value);
  if (theme === 'light') return 'dark';
  if (theme === 'dark') return 'true-dark';
  if (theme === 'true-dark') return 'neon';
  return 'light';
};

export const getThemeBackgroundColor = (value) => {
  const theme = normalizeTheme(value);
  if (theme === 'light') return '#f6f8fb';
  if (theme === 'dark') return '#0b1220';
  if (theme === 'neon') return '#0b0f0d';
  return '#000000';
};

export const applyThemeToDocument = (value) => {
  const theme = normalizeTheme(value);

  if (typeof document === 'undefined') {
    return theme;
  }

  const root = document.documentElement;
  const body = document.body;
  const backgroundColor = getThemeBackgroundColor(theme);
  const colorScheme = theme === 'light' ? 'light' : 'dark';
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const faviconLink = document.querySelector('link[rel~="icon"]');

  root.setAttribute('data-theme', theme);
  root.style.setProperty('background-color', backgroundColor, 'important');
  root.style.setProperty('color-scheme', colorScheme);
  themeColorMeta?.setAttribute('content', backgroundColor);
  faviconLink?.setAttribute('href', theme === 'light' ? '/logoa-02-light.svg' : '/logoa-02-dark.svg');

  if (body) {
    body.setAttribute('data-theme', theme);
    body.style.setProperty('background-color', backgroundColor, 'important');
    body.style.setProperty('color-scheme', colorScheme);
  }

  return theme;
};
